import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { autoinject } from "aurelia-framework";

@autoinject
export class RightShipInspectionApi {

    public rightshipInspectionsApi: string = `${this.configService.config.urls.rightShipPlatformApiUrl}/api/v1/RightShipInspection`;

    constructor(private configService: ConfigService, private requestClientService: RequestClientService) { }
    
    public getDocumentsSubmittedDate(rightshipInspectionId: number, encryptedData: string = null): Promise<string> {
        if (encryptedData)
            return this.requestClientService.get(`${this.rightshipInspectionsApi}/GetDocumentsSubmittedDate/${rightshipInspectionId}`, {encryptedData:encryptedData});
        else
            return this.requestClientService.get(`${this.rightshipInspectionsApi}/GetDocumentsSubmittedDate/${rightshipInspectionId}`, {});
    }
    
    public submitDocuments(rightshipInspectionId : number, importedAttachmentIds: number[]): Promise<boolean> {
        return this.requestClientService.post(`${this.rightshipInspectionsApi}/SubmitDocuments/${rightshipInspectionId}`, {}, {importedAttachmentIds:importedAttachmentIds});
    }
}